import { ReactNode, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { apiClient } from '../../../core/libs/api';
import { HttpResource } from '../../../core/libs/http-resource';
import { AppNotify } from '../../../features/app-notify/app-notify';
import { OrdersCacheProvider } from '../features/orders/orders.provider';
import { OrdersDataStore } from '../features/orders/orders.store';
import {
  getTicketOrdersRequest,
  OrdersData,
} from '../requests/get-ticket-operations.request';

export const UserOrdersCacheProvider = observer(
  ({ children }: { children: ReactNode }) => {
    const [ordersStore] = useState(() => new OrdersDataStore());
    const [getOrdersRequest] = useState(
      () =>
        new HttpResource<void, OrdersData>({
          apiClient,
          httpRequest: getTicketOrdersRequest,
          errorNotify: new AppNotify(),
          onFinish(result) {
            ordersStore.setData(result);
          },
        })
    );
    const [ordersCache] = useState(() => ({ ordersStore, getOrdersRequest }));

    return (
      <OrdersCacheProvider value={ordersCache}>{children}</OrdersCacheProvider>
    );
  }
);
